import { ControllerInterface } from "csi/action/Controller";
import TableWidget from "csi/table/Widget";
import csiView from "csi/view";
import { ViewWidget } from "csi/view/Widget";
import declare from "dojo/_base/declare";
import ApparelBom from "../Model/ApparelBom";
import PartMaterials from "./PartMaterials";

const ProductSizesTable = declare(TableWidget, {


	/**
	 * @override
	 * Make the view read-only if the BOM is a source BOM
	 */
	_resolveView() {
		this.inherited(arguments);
		const bom = this.cacheView.getPathNode(this.urlRoot, "Child:__Parent__");
		const isSourceBOM = ApparelBom.isSourceBOM(bom);
		if (isSourceBOM) {
			this.defView.bReadOnly = true;
		}
	},
	/**
	 * Handle adding sizes to the BOM
	 */
	postActionAddSizes(ac: ControllerInterface): Promise<void> {
		this._postActionUpdatePartMaterials();
		return this.redrawNewData();
	},

	/**
	 * Handle removing a size from the BOM
	 */
	postActionRemoveSize(ac: ControllerInterface): void {
		this._postActionUpdatePartMaterials();
	},

	/**
	 * Notify PartMaterials view of changes to sizes
	 */
	_postActionUpdatePartMaterials(): void {
		const update = (view: ViewWidget): void => {
			const partMaterials = view as PartMaterials;
			partMaterials.refreshOnTabSwitch = true;
			partMaterials.initializeBomSizeSet();
		};

		csiView.getAllViews("PartMaterials")?.forEach(update);
		csiView.getAllViews("HierarchicalPartMaterials")?.forEach(update);
	},
});

export = ProductSizesTable;
